import { render, staticRenderFns } from "./TodoList.vue?vue&type=template&id=3ff30b61&scoped=true"
import script from "./TodoList.vue?vue&type=script&lang=js"
export * from "./TodoList.vue?vue&type=script&lang=js"
import style0 from "./TodoList.vue?vue&type=style&index=0&id=3ff30b61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff30b61",
  null
  
)

export default component.exports